var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoErrors(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 158,
    height: 140,
    viewBox: "0 0 158 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 157.576,
    height: 140,
    rx: 70,
    fill: "#F3E3E0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_306_6118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109.135 47.6114L81.2533 35.4133C80.6483 35.1486 79.9631 35.134 79.3474 35.3727L50.9117 46.3988C50.1431 46.6969 49.5661 47.3438 49.4217 48.1554C47.2965 60.0975 48.9677 94.7569 79.2882 108.911C79.9278 109.21 80.6894 109.209 81.3289 108.91C110.989 95.0633 113.29 64.3335 110.557 49.3773C110.412 48.5859 109.872 47.9339 109.135 47.6114Z",
    stroke: "#DD4F34",
    strokeWidth: 2.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.1457 67.5L74.786 75.1403C75.7493 76.1036 77.3065 76.1183 78.2878 75.1733L93.3957 60.625",
    stroke: "#DD4F34",
    strokeWidth: 2.75,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_306_6118"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 77.5758,
    height: 80,
    fill: "white",
    transform: "translate(40 30)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoErrors);
export default __webpack_public_path__ + "static/media/no-errors.7666463d5e33fae1200d2de379d8183a.svg";
export { ForwardRef as ReactComponent };